module.exports = __webpack_public_path__ + "img/banner5.88cf8548.jpg";